function _defineProperty(t, e, i) {
    return (e = _toPropertyKey(e)) in t ? Object.defineProperty(t, e, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[e] = i, t
}

function _toPropertyKey(t) {
    var e = _toPrimitive(t, "string");
    return "symbol" == typeof e ? e : String(e)
}

function _toPrimitive(t, e) {
    if ("object" != typeof t || null === t) return t;
    var i = t[Symbol.toPrimitive];
    if (void 0 !== i) {
        var s = i.call(t, e || "default");
        if ("object" != typeof s) return s;
        throw TypeError("@@toPrimitive must return a primitive value.")
    }
    return ("string" === e ? String : Number)(t)
}

class ItcSimpleSlider {
    static checkSupportPassiveEvents() {
        let t = !1;
        try {
            let e = Object.defineProperty({}, "passive", {
                get() {
                    t = !0
                }
            });
            window.addEventListener("testPassiveListener", null, e), window.removeEventListener("testPassiveListener", null, e)
        } catch (i) {
            t = !1
        }
        return t
    }

    constructor(t, e) {
        this._el = "string" == typeof t ? document.querySelector(t) : t, this._elWrapper = this._el.querySelector(`.${this.constructor.EL_WRAPPER}`), this._elItems = this._el.querySelector(`.${this.constructor.EL_ITEMS}`), this._elListItem = this._el.querySelectorAll(`.${this.constructor.EL_ITEM}`), this._exOrderMin = 0, this._exOrderMax = 0, this._exItemMin = null, this._exItemMax = null, this._exTranslateMin = 0, this._exTranslateMax = 0, this._states = [], this._isBalancing = !1, this._direction = "next", this._transform = 0, this._clientRect = this._elWrapper.getBoundingClientRect(), this._supportResizeObserver = void 0 !== window.ResizeObserver;
        let i = window.getComputedStyle(this._elItems);
        if (this._delay = Math.round(50 * parseFloat(i.transitionDuration)), this._hasSwipeState = !1, this._swipeStartPosX = 0, this._intervalId = null, this._config = {
            loop: !0,
            autoplay: !1,
            interval: 5e3,
            indicators: !0,
            swipe: !0, ...e
        }, this._elItems.dataset.translate = "0", this._elListItem.forEach((t, e) => {
            t.dataset.order = `${e}`, t.dataset.index = `${e}`, t.dataset.translate = "0", this._states.push(0 === e ? 1 : 0)
        }), this._config.loop) {
            let s = this._elListItem.length - 1, r = -this._elListItem.length;
            this._elListItem[s].dataset.order = "-1", this._elListItem[s].dataset.translate = `${-this._elListItem.length}`;
            let a = r * this._clientRect.width;
            this._elListItem[s].style.transform = `translate3D(${a}px, 0px, 0.1px)`
        }
        this._addIndicators(), this._elListIndicator = document.querySelectorAll(`.${this.constructor.EL_INDICATOR}`), this._updateExProperties(), this._changeActiveItems(), this._addEventListener(), this._autoplay()
    }

    _changeActiveItems() {

        if(this._el.id === 'home-price-itcss'){
            let active = document.querySelector('#homes-price').dataset.translate;
            let ind_act = Math.abs(parseInt(active));

            document.querySelectorAll('#homes-price .itcss__item').forEach(element => {
                element.classList.remove('itcss__item_active');
                element.classList.remove('itcss__item_active_next');
                element.classList.add('itcss__item_active_hidden');
            });


                let activeel = document.querySelector('#homes-price .itcss__item[data-index="' + ind_act + '"]');
                if(activeel){
                    activeel.classList.add('itcss__item_active');
                    activeel.classList.remove('itcss__item_active_hidden');
                    activeel.classList.remove('itcss__item_active_next');
                    let next_index =  ind_act + 1;

                    let next =  document.querySelector('#homes-price .itcss__item[data-index="' + next_index + '"]');

                    if(next){
                        next.classList.remove('itcss__item_active');
                        next.classList.remove('itcss__item_active_hidden');
                        next.classList.add('itcss__item_active_next');
                    }
                }









        }else{




        }




        this._states.forEach((t, e) => {
            t ? this._elListItem[e].classList.add(this.constructor.EL_ITEM_ACTIVE) : this._elListItem[e].classList.remove(this.constructor.EL_ITEM_ACTIVE), this._elListIndicator.length && t ? this._elListIndicator[e].classList.add(this.constructor.EL_INDICATOR_ACTIVE) : this._elListIndicator.length && !t && this._elListIndicator[e].classList.remove(this.constructor.EL_INDICATOR_ACTIVE)
        }), this._el.dispatchEvent(new CustomEvent("change.itc.slider", {bubbles: !0}))


        let flag = false

        this._states.forEach((t, e) => {




            if (flag){
                this._elListItem[e].classList.add('itcss__item_active_next');
                this._elListItem[e].classList.remove('itcss__item_active_hidden');
                flag = false
            }else{
                this._elListItem[e].classList.remove('itcss__item_active_next');
                if(this._elListItem[e].classList.contains('itcss__item_active')){

                }else{
                    this._elListItem[e].classList.add('itcss__item_active_hidden');
                }
            }
           if(this._elListItem[e].classList.contains('itcss__item_active')){

               flag = true
               this._elListItem[e].classList.remove('itcss__item_active_next');
               this._elListItem[e].classList.remove('itcss__item_active_hidden');


               let sl_index =   this._elListItem[e].dataset.index;





               if(sl_index){
                   let wrap_elem = false;

                   let wrap_elem_pr = this._elListItem[e].parentNode;

                   if(wrap_elem_pr){
                       wrap_elem = wrap_elem_pr.parentNode.parentNode;
                   }



                   if (wrap_elem){

                       let actives =   wrap_elem.querySelector('.itcss__indicator_active');
                       if(actives){
                           actives.classList.remove('itcss__indicator_active');
                       }


                       wrap_elem.querySelector("[data-slide-to='" + sl_index + "']").classList.add('itcss__indicator_active');
                   }



               }



           }








            if(this._elListItem[e].classList.contains('itcss__item_active')){

            }else if(this._elListItem[e].classList.contains('itcss__item_active_next')){

            }else{
                this._elListItem[e].classList.add('itcss__item_active_hidden');
            }



        });





    }

    _move() {
        if (this._elItems.classList.remove(this.constructor.TRANSITION_NONE), "none" === this._direction) {
            let t = this._transform * this._clientRect.width;
            this._elItems.style.transform = `translate3D(${t}px, 0px, 0.1px)`;
            return
        }
        if (!this._config.loop) {
            let e = this._states[0] && "prev" === this._direction,
                i = this._states[this._states.length - 1] && "next" === this._direction;
            if (e || i) {
                this._autoplay("stop");
                return
            }
        }
        this._transform += "next" === this._direction ? -1 : 1, "next" === this._direction ? this._states = [...this._states.slice(-1), ...this._states.slice(0, -1)] : "prev" === this._direction && (this._states = [...this._states.slice(1), ...this._states.slice(0, 1)]), this._elItems.dataset.translate = this._transform;
        let s = this._transform * this._clientRect.width;
        this._elItems.style.transform = `translate3D(${s}px, 0px, 0.1px)`, this._elItems.dispatchEvent(new CustomEvent("moving.itc.slider", {bubbles: !0})), this._changeActiveItems(), this._isBalancing || (this._isBalancing = !0, window.requestAnimationFrame(this._balanceItems.bind(this)))
    }

    _moveTo(t) {
        let e = this._states.indexOf(1);
        this._direction = t > e ? "next" : "prev";
        for (let i = 0; i < Math.abs(t - e); i++) this._move()
    }

    _autoplay(t) {
        if (this._config.autoplay) {
            if ("stop" === t) {
                clearInterval(this._intervalId), this._intervalId = null;
                return
            }
            null === this._intervalId && (this._intervalId = setInterval(() => {
                this._direction = "next", this._move()
            }, this._config.interval))
        }
    }

    _addIndicators() {
        let t = this._el.querySelector(`.${this.constructor.EL_INDICATORS}`);
        if (t || !this._config.indicators) return;
        let e = "";
        for (let i = 0, {length: s} = this._elListItem; i < s; i++) e += `<li class="${this.constructor.EL_INDICATOR}" data-slide-to="${i}"></li>`;
        let r = `<ol class="${this.constructor.EL_INDICATORS}">${e}</ol>`;
        this._el.insertAdjacentHTML("beforeend", r)
    }

    _updateExProperties() {
        let t = Object.values(this._elListItem).map(t => t), e = t.map(t => Number(t.dataset.order));
        this._exOrderMin = Math.min(...e), this._exOrderMax = Math.max(...e);
        let i = e.indexOf(this._exOrderMin), s = e.indexOf(this._exOrderMax);
        this._exItemMin = t[i], this._exItemMax = t[s], this._exTranslateMin = Number(this._exItemMin.dataset.translate), this._exTranslateMax = Number(this._exItemMax.dataset.translate)
    }

    _balanceItems() {
        if (this._isBalancing) {
            if ("next" === this._direction) {
                let t = this._exItemMin.getBoundingClientRect().right;
                if (t < this._clientRect.left - this._clientRect.width / 2) {
                    this._exItemMin.dataset.order = `${this._exOrderMin + this._elListItem.length}`, this._exItemMin.dataset.translate = `${this._exTranslateMin + this._elListItem.length}`;
                    let e = (this._exTranslateMin + this._elListItem.length) * this._clientRect.width;
                    this._exItemMin.style.transform = `translate3D(${e}px, 0px, 0.1px)`, this._updateExProperties()
                }
            } else {
                let i = this._exItemMax.getBoundingClientRect().left;
                if (i > this._clientRect.right + this._clientRect.width / 2) {
                    this._exItemMax.dataset.order = `${this._exOrderMax - this._elListItem.length}`, this._exItemMax.dataset.translate = `${this._exTranslateMax - this._elListItem.length}`;
                    let s = (this._exTranslateMax - this._elListItem.length) * this._clientRect.width;
                    this._exItemMax.style.transform = `translate3D(${s}px, 0px, 0.1px)`, this._updateExProperties()
                }
            }
            window.setTimeout(() => {
                window.requestAnimationFrame(this._balanceItems.bind(this))
            }, this._delay)
        }
    }

    _addEventListener() {
        let t = t => {
            if (this._autoplay("stop"), t.target.closest(`.${this.constructor.EL_CONTROL}`)) return;
            let e = 0 === t.type.search("touch") ? t.touches[0] : t;
            this._swipeStartPosX = e.clientX, this._swipeStartPosY = e.clientY, this._hasSwipeState = !0, this._hasSwiping = !1
        }, e = t => {
            if (!this._hasSwipeState) return;
            let e = 0 === t.type.search("touch") ? t.touches[0] : t, i = this._swipeStartPosX - e.clientX,
                s = this._swipeStartPosY - e.clientY;
            if (!this._hasSwiping) {
                if (Math.abs(s) > Math.abs(i) || 0 === Math.abs(i)) {
                    this._hasSwipeState = !1;
                    return
                }
                this._hasSwiping = !0
            }
            if (t.preventDefault(), !this._config.loop) {
                let r = this._states[0] && i <= 0, a = this._states[this._states.length - 1] && i >= 0;
                (r || a) && (i /= 4)
            }
            this._elItems.classList.add(this.constructor.TRANSITION_NONE);
            let l = this._transform * this._clientRect.width - i;
            this._elItems.style.transform = `translate3D(${l}px, 0px, 0.1px)`
        }, i = t => {
            if (!this._hasSwipeState) return;
            let e = 0 === t.type.search("touch") ? t.changedTouches[0] : t, i = this._swipeStartPosX - e.clientX;
            if (0 === i) {
                this._hasSwipeState = !1;
                return
            }
            if (!this._config.loop) {
                let s = this._states[0] && i <= 0, r = this._states[this._states.length - 1] && i >= 0;
                (s || r) && (i = 0)
            }
            let a = i / this._clientRect.width * 100;
            this._elItems.classList.remove(this.constructor.TRANSITION_NONE), a > this.constructor.SWIPE_THRESHOLD ? (this._direction = "next", this._move()) : a < -this.constructor.SWIPE_THRESHOLD ? (this._direction = "prev", this._move()) : (this._direction = "none", this._move()), this._hasSwipeState = !1, this._autoplay()
        };
        if (this._el.addEventListener("click", t => {
            let e = t.target;
            if (this._autoplay("stop"), e.classList.contains(this.constructor.EL_CONTROL)) t.preventDefault(), this._direction = e.dataset.slide, this._move(); else if (e.dataset.slideTo) {
                t.preventDefault();
                let i = parseInt(e.dataset.slideTo, 10);
                this._moveTo(i)
            }
            this._autoplay()
        }), this._config.loop && this._elItems.addEventListener("transitionend", () => {
            this._isBalancing = !1
        }), this._el.addEventListener("mouseenter", () => {
            this._autoplay("stop")
        }), this._el.addEventListener("mouseleave", () => {
            this._autoplay()
        }), this._config.swipe) {
            let s = !!this.constructor.checkSupportPassiveEvents() && {passive: !1};
            this._el.addEventListener("touchstart", t, s), this._el.addEventListener("touchmove", e, s), this._el.addEventListener("mousedown", t), this._el.addEventListener("mousemove", e), document.addEventListener("touchend", i), document.addEventListener("mouseup", i), document.addEventListener("mouseout", i)
        }
        if (this._el.addEventListener("dragstart", t => {
            t.preventDefault()
        }), document.addEventListener("visibilitychange", () => {
            "visible" === document.visibilityState && this._config.loop ? this._autoplay() : this._autoplay("stop")
        }), this._supportResizeObserver) {
            let r = new ResizeObserver(t => {
                let {contentRect: e} = t[0];
                if (Math.round(10 * this._clientRect.width) === Math.round(10 * e.width)) return;
                this._clientRect = e;
                let i = e.width * Number(this._elItems.dataset.translate);
                this.reset(i, !0), this._autoplay()
            });
            r.observe(this._elWrapper)
        }
    }

    reset(t = 0, e = !1) {
        if (this._autoplay("stop"), this._elItems.classList.add(this.constructor.TRANSITION_NONE), this._elItems.style.transform = `translate3D(${t}px, 0px, 0.1px)`, this._elListItem.forEach(t => {
            let i = e ? Number(t.dataset.translate) * this._clientRect.width : 0;
            t.style.transform = `translate3D(${i}px, 0px, 0.1px)`
        }), !e) {
            if (this._transform = 0, this._states = [], this._elItems.dataset.translate = "0", this._elListItem = this._el.querySelectorAll(`.${this.constructor.EL_ITEM}`), this._elListItem.forEach((t, e) => {
                t.dataset.order = `${e}`, t.dataset.index = `${e}`, t.dataset.translate = "0", this._states.push(0 === e ? 1 : 0)
            }), this._config.loop) {
                let i = this._elListItem.length - 1, s = -this._elListItem.length;
                this._elListItem[i].dataset.order = "-1", this._elListItem[i].dataset.translate = `${-this._elListItem.length}`;
                let r = s * this._clientRect.width;
                this._elListItem[i].style.transform = `translate3D(${r}px, 0px, 0.1px)`
            }
            this._el.querySelector(`.${this.constructor.EL_INDICATORS}`).remove(), this._addIndicators(), this._elListIndicator = document.querySelectorAll(`.${this.constructor.EL_INDICATOR}`), this._updateExProperties(), this._changeActiveItems()
        }
        this._autoplay()
    }

    next() {
        this._direction = "next", this._move()
    }

    prev() {
        this._direction = "prev", this._move()
    }

    autoplay() {
        this._autoplay("stop")
    }

    moveTo(t) {
        this._moveTo(t)
    }
}

_defineProperty(ItcSimpleSlider, "PREFIX", "itcss"), _defineProperty(ItcSimpleSlider, "EL_WRAPPER", `${ItcSimpleSlider.PREFIX}__wrapper`), _defineProperty(ItcSimpleSlider, "EL_ITEM", `${ItcSimpleSlider.PREFIX}__item`), _defineProperty(ItcSimpleSlider, "EL_ITEM_ACTIVE", `${ItcSimpleSlider.PREFIX}__item_active`), _defineProperty(ItcSimpleSlider, "EL_ITEMS", `${ItcSimpleSlider.PREFIX}__items`), _defineProperty(ItcSimpleSlider, "EL_INDICATOR", `${ItcSimpleSlider.PREFIX}__indicator`),

   // _defineProperty(ItcSimpleSlider, "EL_INDICATOR_ACTIVE", `${ItcSimpleSlider.PREFIX}__indicator_active`),

    _defineProperty(ItcSimpleSlider, "EL_INDICATORS", `${ItcSimpleSlider.PREFIX}__indicators`), _defineProperty(ItcSimpleSlider, "EL_CONTROL", `${ItcSimpleSlider.PREFIX}__btn`), _defineProperty(ItcSimpleSlider, "SWIPE_THRESHOLD", 20), _defineProperty(ItcSimpleSlider, "TRANSITION_NONE", "transition-none");


function adaptiveSlider(blankElementId, sliderElementClass, points, props, addClass = false) {
    let blank = document.getElementById(blankElementId)




    let adaptiveElem = blank.children;
    let out = '';
    let targetElem = document.getElementById(blank.dataset.target);
    let itemMaxCount = 1;

    if (window.matchMedia("(max-width: 330px)").matches) {
        itemMaxCount = points[0];
    } else if (window.matchMedia("(max-width: 720px)").matches) {
        itemMaxCount = points[1];
    } else if (window.matchMedia("(max-width: 768px)").matches) {
        itemMaxCount = points[2];
    } else if (window.matchMedia("(max-width: 1199px)").matches) {
        itemMaxCount = points[2];
    } else if (window.matchMedia("(min-width: 1200px)").matches) {
        itemMaxCount = points[3];
    }
    if(addClass){
        out += '<div class="itcss__item ' + addClass + '">';
    }else{
        out += '<div class="itcss__item">';
    }

    itemCount = 0;
    for (let elem of adaptiveElem) {


        if (itemCount >= itemMaxCount) {
            out += '</div>';
            out += '<div class="itcss__item">';
            itemCount = 0;
        }
        out += elem.innerHTML;

        itemCount++;
    }
    out += '</div>';



    targetElem.innerHTML = out;
    blank.remove();




    return new ItcSimpleSlider(sliderElementClass, {
        loop: false,
        autoplay: false,
        swipe: true
    });


}
document.addEventListener('DOMContentLoaded', function() {




   FS('.service-info__filter-service-praktika .filter-select-item', 'all').onClick(function (){
      FS('.service-info__filter-service-praktika .filter-select-item--selected').removeClass('filter-select-item--selected');
      FS(this).addClass('filter-select-item--selected');
       showSelected();
   });




});

function setServiceTeoriya(){
    FS('.filter-select-item-set-teoriya').addClass('filter-select-item--selected');
    FS('.filter-select-item-set-praktica').removeClass('filter-select-item--selected');
    FS('.service-info__content-item[data-post="teoriya"]').addUniqueClass('service-info__content-item--show');
    FS('.service-info__filter-service-praktika').hide();
}

function setServicePraktika(){
    FS('.filter-select-item-set-praktica').addClass('filter-select-item--selected');
    FS('.filter-select-item-set-teoriya').removeClass('filter-select-item--selected');
    FS('.service-info__filter-service-praktika').show();
    showSelected();
}

function showSelected(){
    let item =  FS('.service-info__filter-service-praktika .filter-select-item--selected');
    let post = item.getData('post');
    FS('.service-info__content-item[data-post="' + post + '"]').addUniqueClass('service-info__content-item--show');
}
document.addEventListener('DOMContentLoaded', function() {


    FS('.schedule .filter-schedule-type', 'all').onClick(function (){
      // FS(this).addUniqueClass('filter-select-item--selected');

        FS('.schedule .filter-select-item--selected').removeClass('filter-select-item--selected');
        FS(this).addClass('filter-select-item--selected');


        scheduleFilter();
    });

    FS('.schedule .filter-radio-item', 'all').onClick(function (){
        FS(this).addUniqueClass('filter-radio-item--checked');
        scheduleFilter();
    });

    FS('.schedule__item', 'all').onClick(function (){
       FS(this).addUniqueClass('schedule__item--selected');
    });



    FS('.schedule__join', 'all').onClick(function (){
        let selected_title = '';
        let selected_time = '';
        let selected_info = '';
        if(document.querySelector('.schedule .schedule__item--selected')){
             selected_title = FS('.schedule .schedule__item--selected .schedule__item-name').getText();
             selected_time = FS('.schedule .schedule__item--selected .schedule__item-time').getText();
             selected_info = FS('.schedule .schedule__item--selected .schedule__item-type').getHtml();
        }else{
             selected_title = FS('.schedule .schedule__item .schedule__item-name').getText();
             selected_time = FS('.schedule .schedule__item .schedule__item-time').getText();
             selected_info = FS('.schedule .schedule__item .schedule__item-type').getHtml();
        }


        FS('.schedule__popup .schedule__popup-text-primary').setText(selected_title);
        FS('.schedule__popup .schedule__popup-text-secondary').setHtml(selected_info);
        FS('.schedule__popup .schedule__popup-time').setText(selected_time);

        popup('.schedule__popup').show();


    });


});


function scheduleFilter(){

    let selected_type = FS('.schedule .filter-select-item--selected').getData('type');
    let selected_mode = FS('.schedule .filter-radio-item--checked').getData('mode');

    let schedule_items = FS('.schedule__item', 'all').elements();

    let i = 0;

    schedule_items.forEach(element => {
        if(element.classList.contains('schedule__' + selected_type) && element.classList.contains('schedule__' + selected_mode)){
            if(i === 0){
                FS(element).addUniqueClass('schedule__item--selected');
            }
            i++;
            element.querySelector('.schedule__item-num').innerText = i + ' /';
            element.classList.add('schedule--show');
        }else{
            element.classList.remove('schedule--show');
        }

    });







}
class __fs_popup{

    selector;

    constructor(selector) {
        this.selector = FS(selector);
    }

    show(){
        this.hideAll();
        this.selector.addUniqueClass('popup--active');
        FS('body').addClass('popup-showing');
    }

    hideAll(){
        FS('.popup--active', 'all').removeClass('popup--active');
        FS('body').removeClass('popup-showing');
    }


}


function popup(selector = null){
    return new __fs_popup(selector);
}
document.addEventListener('DOMContentLoaded', function() {
    FS('.popup-close-btn', 'all').onClick(function (){
       popup().hideAll();
    });
});
document.addEventListener('DOMContentLoaded', function() {
   FS('.faq__item', 'all').onClick(function (){
      if (this.classList.contains('faq--active')) {
         FS(this).removeClass('faq--active');
      }else{
         FS(this).addUniqueClass('faq--active');
      }


   });
});

document.addEventListener('DOMContentLoaded', function() {


    if (document.getElementsByClassName('car__slider').length > 0) {

        let cars_slider = adaptiveSlider(
            'home-cars',
            '#home-cars-itcss',
            [1, 1, 2, 2],
            {
                loop: false,
                autoplay: false,
                swipe: true
            }
        );


        document.getElementById('home-cars-next').addEventListener("click", function (){
            cars_slider.next();
        });
        document.getElementById('home-cars-prev').addEventListener("click", function (){
            cars_slider.prev();
        });




    }











});